import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";
import theme from "tools/theme";

export default makeStyles(({ palette, spacing }) => ({
  root: {
    maxWidth: "230px",
    flexWrap: "wrap",
    padding: spacing(1, 0),
  },
  chip: {
    color: palette.primary.main,
    background: palette.secondary.main,
    textTransform: "capitalize",
    height: "28px",
    "&:focus": {
      background: palette.secondary.main,
    },
    "&:hover": {
      background: "rgba(41, 121, 255, 0.15)",
    },
  },
  autocompleteChip: {
    marginLeft: spacing(1),
  },
  chipDeleteIcon: {
    cursor: "pointer",
    "&:hover path": {
      fill: palette.primary.main,
    },
  },
  inputRoot: {
    display: "flex",
    marginTop: spacing(1),
    width: 150,
  },
  input: {
    "& input": {
      padding: spacing(1, 0.5),
      fontSize: "12px",
      height: 0,
    },
    "& fieldset": {
      borderColor: palette.primary.main,
    },
  },
  paperComponent: {
    width: 267,
    marginBlock: spacing(0.5),
    paddingBottom: spacing(1),
    backgroundColor: "white",
    border: `1px solid ${grey[100]}`,
    borderRadius: spacing(1),
  },
  menuItem: {
    borderRadius: spacing(0.5),
    minHeight: 45,
    padding: 0,
    "&:hover": {
      backgroundColor: "inherit",
    },
  },
  maxCountWarning: {
    color: `${palette.warning.main} !important`,
    opacity: "1 !important",
    borderTop: `1px solid ${theme.palette.divider}`,
    paddingTop: spacing(1),
    padding: 0,
  },
  createNewTag: {
    fontWeight: 600,
    lineHeight: "24px",
  },
}));
